<span *ngIf="captureSnapshot.processing; else: snapshotLink"> Processing... </span>
<ng-template #snapshotLink>
  <a *ngIf="canDownload; else: snapshotStatus" href="javascript:;" (click)="onDownloadClick()">
    {{ captureSnapshot.filename }}
  </a>
</ng-template>
<ng-template #snapshotStatus>
  <span> {{ captureSnapshot.status | titlecase }} </span>
</ng-template>
